// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../types';
import type { ColorScheme } from '../../../../types/theme';

type Props = {
  scheme: ColorScheme,
};

const Minus = styled<any, Theme, Props>('div')`
  align-items: center;
  display: flex;
  flex-shrink: 0;
  height: 1em;
  justify-content: center;
  margin-left: 0.2em;
  margin-right: 0.2em;
  margin-top: 0.2em;
  width: 0.9em;

  &:after {
    content: '';
    background-color: ${({ scheme, theme }) => scheme.icons || theme.list.listStyles.minus.color};
    height: 0.2em;
    width: 0.9em;
  }
`;

export default Minus;
